import React, { useCallback, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const TOOLTIP_GAP = 8;

function portalStyle(align, rect) {
  if (align === 'end') {
    return {
      top: rect.top - TOOLTIP_GAP,
      left: rect.right,
      transform: 'translate(-100%, -100%)',
    };
  }
  if (align === 'start') {
    return {
      top: rect.top - TOOLTIP_GAP,
      left: rect.left,
      transform: 'translateY(-100%)',
    };
  }
  return {
    top: rect.top - TOOLTIP_GAP,
    left: rect.left + rect.width / 2,
    transform: 'translate(-50%, -100%)',
  };
}

function portalClass(align, compact) {
  return [
    'cx-exp-tooltip',
    'cx-exp-tooltip--portal',
    align === 'end' ? 'cx-exp-tooltip--portal-end' : '',
    align === 'start' ? 'cx-exp-tooltip--portal-start' : '',
    compact ? 'cx-exp-tooltip--portal-compact' : '',
  ]
    .filter(Boolean)
    .join(' ');
}

export default function CxExpAnchorTooltip({ text, align = 'start', compact = false, children }) {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [rect, setRect] = useState(null);

  const show = useCallback(() => {
    const el = anchorRef.current;
    if (!el) return;
    setRect(el.getBoundingClientRect());
    setOpen(true);
  }, []);

  const hide = useCallback(() => {
    setOpen(false);
    setRect(null);
  }, []);

  return (
    <span
      ref={anchorRef}
      className="cx-exp-tooltip-wrap"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      {children}
      {open && rect
        ? createPortal(
            <span className={portalClass(align, compact)} style={portalStyle(align, rect)} role="tooltip">
              {text}
            </span>,
            document.body
          )
        : null}
    </span>
  );
}
